<section class="signature-request-summary-section">
    <!-- <div class="signature-summary-header">
        <span class="status-badge-container">
            <signature-request-status-badge [status]="signatureRequestSummary?.status"></signature-request-status-badge>
        </span>
    </div> -->
    <div class="signature-request-summary-inner">
        <div class="signature-request-item">
            <span class="header">Creado</span>
            <span>{{ signatureRequestSummary?.createdAt| date:'short' }} </span>
        </div>
        <div class="signature-request-item">
            <span class="header">Enviado</span>
            <span>{{ signatureRequestSummary?.sentAt| date:'short' }}  </span>
        </div>
        <div class="signature-request-item">
            <span class="header">Finalizado</span>
            <span>{{ signatureRequestSummary?.finalizedAt| date:'short' }}  </span>
        </div>
        <div class="signature-request-item">
            <span class="header">Tipo de Firma</span>
            <span>{{ signatureRequestSummary?.signatureType }}  </span>
        </div>
        <div class="signature-request-item">
            <span class="header">Estado</span>
            <signature-request-status-badge [status]="signatureRequestSummary?.status"></signature-request-status-badge>
        </div>        
    </div>
    <div class="signature-request-observation">
        <div class="signature-request-item">
            <span class="header">Observación</span>
            <span>{{ signatureRequestSummary?.observation || 'N/A' }}  </span>
        </div>

    </div>
    
</section>